import { render, staticRenderFns } from "./platform-picker.vue?vue&type=template&id=874de1a2"
import script from "./platform-picker.vue?vue&type=script&lang=ts"
export * from "./platform-picker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports